// import { Link } from "react-router-dom";
// import {
//   Globe,
//   Smartphone,
//   ShoppingCart,
//   Cloud,
//   BarChart3,
//   Headphones,
//   Brain,
//   Database,
//   ImageIcon,
//   Video,
//   Box,
//   Tag,
//   MessageSquare,
//   Layers,
//   Users,
//   Zap,
//   Receipt,
//   Cpu,
//   SearchCode,
//   Languages,
// } from "lucide-react";

// /* ------------------ DATA ------------------ */
// const servicesMenu = [
//   {
//     label: "Website Development",
//     path: "/services/web",
//     icon: <Globe size={24} />,
//     desc: "Architecting high-performance, scalable web ecosystems.",
//   },
//   {
//     label: "Mobile App Development",
//     path: "/services/mobile",
//     icon: <Smartphone size={24} />,
//     desc: "Engineering native and cross-platform mobile experiences.",
//   },
//   {
//     label: "E-Commerce Solutions",
//     path: "/services/ecommerce",
//     icon: <ShoppingCart size={24} />,
//     desc: "Conversion-optimized digital storefronts with integrated billing.",
//   },
//   {
//     label: "Cloud & DevOps",
//     path: "/services/cloud",
//     icon: <Cloud size={24} />,
//     desc: "Enterprise-grade infrastructure orchestration on AWS/Azure.",
//   },
//   {
//     label: "AI Training Data",
//     path: "/services/ai-training",
//     icon: <Cpu size={24} />,
//     desc: "Engineering high-fidelity ground truth datasets for model convergence.",
//   },
//   {
//     label: "Transcription & Translation",
//     path: "/services/transcription",
//     icon: <Languages size={24} />,
//     desc: "Multi-linguistic conversion and professional localization services.",
//   },
//   {
//     label: "NLP & LLM Datasets",
//     path: "/services/nlp-llm",
//     icon: <Brain size={24} />,
//     desc: "Specialized text corpora for large language model training.",
//   },
//   {
//     label: "Video Dataset Services",
//     path: "/services/video",
//     icon: <Video size={24} />,
//     desc: "Frame-accurate temporal annotations for computer vision.",
//   },
//   {
//     label: "Image Dataset Services",
//     path: "/services/image-photo",
//     icon: <ImageIcon size={24} />,
//     desc: "High-resolution annotated visual data for object detection.",
//   },
//   {
//     label: "Audio & Voice Datasets",
//     path: "/services/audio-voice",
//     icon: <Database size={24} />,
//     desc: "Curated acoustic datasets for speech recognition systems.",
//   },
//   {
//     label: "2D & 3D Dataset Services",
//     path: "/services/2d3d",
//     icon: <Box size={24} />,
//     desc: "Spatial labeling and dimensional data mapping for robotics.",
//   },
//   {
//     label: "Categorizing & Tagging",
//     path: "/services/categorizing-tagging",
//     icon: <Tag size={24} />,
//     desc: "Hierarchical metadata structuring for enterprise assets.",
//   },
//   {
//     label: "Phonetic Transcription",
//     path: "/services/phonetic-transcription",
//     icon: <SearchCode size={24} />,
//     desc: "Granular phonetic level mapping for acoustic research.",
//   },
//   {
//     label: "Digital Marketing",
//     path: "/services/digital",
//     icon: <BarChart3 size={24} />,
//     desc: "Strategic growth orchestration and data-driven SEO.",
//   },
// ];

// const productsMenu = [
//   {
//     label: "Enterprise ERP",
//     path: "/Erp",
//     icon: <Layers size={24} />,
//     desc: "Unified resource planning for multi-branch business orchestration.",
//   },
//   {
//     label: "CRM & Billing",
//     path: "/Crm",
//     icon: <Users size={24} />,
//     desc: "Advanced relationship management with integrated billing logic.",
//   },
//   {
//     label: "Advanced HRM",
//     path: "/Hrm",
//     icon: <Zap size={24} />,
//     desc: "Workforce management from recruitment to payroll execution.",
//   },
//   {
//     label: "Billing Software",
//     path: "/Billing",
//     icon: <Receipt size={24} />,
//     desc: "Automated invoicing and fiscal reporting architectures.",
//   },
// ];

// export default function ServicesAndProducts() {
//   return (
//     <section className="font-inter overflow-hidden">
//       {/* ========== SERVICES SECTION ========== */}
//       <div className="bg-slate-50 py-20 border-b border-slate-200">
//         <div className="max-w-7xl mx-auto px-6 mb-12">
//           <span className="text-indigo-600 font-black tracking-[0.2em] uppercase text-[10px]">
//             Engineering Capabilities
//           </span>
//           <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 tracking-tight">
//             High-Fidelity Services
//           </h2>
//         </div>

//         <div className="relative flex group">
//           <div className="flex animate-marquee whitespace-nowrap gap-5 py-4">
//             {[...servicesMenu, ...servicesMenu].map((item, index) => (
//               <NavigationCard key={index} item={item} />
//             ))}
//           </div>
//         </div>

//         <div className="max-w-7xl mx-auto px-6 mt-10">
//           <Link
//             to="/services"
//             className="inline-flex items-center gap-3 bg-white border border-slate-200 px-6 py-2.5 rounded-full text-slate-900 font-bold text-sm uppercase tracking-widest hover:border-indigo-600 hover:shadow-lg transition-all group"
//           >
//             Explore All Services
//             <span className="bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs group-hover:rotate-45 transition-transform duration-300">
//               ↗
//             </span>
//           </Link>
//         </div>
//       </div>

//       {/* ========== PRODUCTS SECTION ========== */}
//       <div className="bg-white py-20">
//         <div className="max-w-7xl mx-auto px-6 mb-12 text-right">
//           <span className="text-indigo-600 font-black tracking-[0.2em] uppercase text-[10px]">
//             Technical Solutions
//           </span>
//           <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 tracking-tight">
//             Proprietary Software Suite
//           </h2>
//         </div>

//         <div className="relative flex group">
//           <div className="flex animate-marquee-reverse whitespace-nowrap gap-5 py-4">
//             {[...productsMenu, ...productsMenu, ...productsMenu].map(
//               (item, index) => (
//                 <NavigationCard key={index} item={item} />
//               ),
//             )}
//           </div>
//         </div>

//         <div className="max-w-7xl mx-auto px-6 mt-10 flex justify-end">
//           <Link
//             to="/products"
//             className="inline-flex items-center gap-3 bg-white border border-slate-200 px-6 py-2.5 rounded-full text-slate-900 font-bold text-sm uppercase tracking-widest hover:border-indigo-600 hover:shadow-lg transition-all group"
//           >
//             View Product Suite
//             <span className="bg-[#4f46e5] text-white w-6 h-6 rounded-full flex items-center justify-center text-xs group-hover:rotate-45 transition-transform duration-300">
//               ↗
//             </span>
//           </Link>
//         </div>
//       </div>

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//         @keyframes marquee {
//           0% { transform: translateX(0%); }
//           100% { transform: translateX(-50%); }
//         }
//         @keyframes marquee-reverse {
//           0% { transform: translateX(-50%); }
//           100% { transform: translateX(0%); }
//         }
//         .animate-marquee { animation: marquee 50s linear infinite; }
//         .animate-marquee-reverse { animation: marquee-reverse 30s linear infinite; }
//         .group:hover .animate-marquee,
//         .group:hover .animate-marquee-reverse { animation-play-state: paused; }
//       `,
//         }}
//       />
//     </section>
//   );
// }

// /* ------------------ REUSABLE NAVIGATION CARD ------------------ */

// function NavigationCard({ item }) {
//   return (
//     <Link
//       to={item.path}
//       className="w-[320px] bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:border-indigo-500 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col items-start group"
//     >
//       {/* Icon logic: group-hover specifically targets this card's icon only */}
//       <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 mb-6 transition-colors duration-300 group-hover:bg-indigo-600 group-hover:text-white">
//         {item.icon}
//       </div>
//       <h3 className="text-sm font-bold text-slate-900 mb-2 uppercase tracking-tight whitespace-normal">
//         {item.label}
//       </h3>
//       <p className="text-slate-500 text-xs leading-relaxed whitespace-normal mb-4">
//         {item.desc}
//       </p>
//       <p className="text-indigo-600 text-[9px] font-black uppercase tracking-[0.2em] opacity-70 group-hover:opacity-100 transition-opacity">
//         Technical Specs ⟶
//       </p>
//     </Link>
//   );
// }

import { Link } from "react-router-dom";
import {
  Globe,
  Smartphone,
  ShoppingCart,
  Cloud,
  BarChart3,
  Layers,
  Users,
  Zap,
  Receipt,
  Cpu,
  Languages,
  Brain,
  Video,
  ImageIcon,
  Database,
  Box,
  Tag,
  SearchCode,
} from "lucide-react";

/* ------------------ DATA (Kept same) ------------------ */
const servicesMenu = [
  {
    label: "Website Development",
    path: "/services/web",
    icon: <Globe size={24} />,
    desc: "Architecting high-performance, scalable web ecosystems.",
  },
  {
    label: "Mobile App Development",
    path: "/services/mobile",
    icon: <Smartphone size={24} />,
    desc: "Engineering native and cross-platform mobile experiences.",
  },
  {
    label: "E-Commerce Solutions",
    path: "/services/ecommerce",
    icon: <ShoppingCart size={24} />,
    desc: "Conversion-optimized digital storefronts.",
  },
  {
    label: "Cloud & DevOps",
    path: "/services/cloud",
    icon: <Cloud size={24} />,
    desc: "Enterprise-grade infrastructure orchestration.",
  },
  {
    label: "AI Training Data",
    path: "/services/ai-training",
    icon: <Cpu size={24} />,
    desc: "Engineering high-fidelity ground truth datasets.",
  },
  {
    label: "Transcription & Translation",
    path: "/services/transcription",
    icon: <Languages size={24} />,
    desc: "Multi-linguistic conversion and localization.",
  },
  {
    label: "NLP & LLM Datasets",
    path: "/services/nlp-llm",
    icon: <Brain size={24} />,
    desc: "Specialized text corpora for LLM training.",
  },
  {
    label: "Video Dataset Services",
    path: "/services/video",
    icon: <Video size={24} />,
    desc: "Frame-accurate temporal annotations.",
  },
  {
    label: "Image Dataset Services",
    path: "/services/image-photo",
    icon: <ImageIcon size={24} />,
    desc: "High-resolution annotated visual data.",
  },
  {
    label: "Audio & Voice Datasets",
    path: "/services/audio-voice",
    icon: <Database size={24} />,
    desc: "Curated acoustic datasets for speech.",
  },
  {
    label: "2D & 3D Dataset Services",
    path: "/services/2d3d",
    icon: <Box size={24} />,
    desc: "Spatial labeling for robotics.",
  },
  {
    label: "Categorizing & Tagging",
    path: "/services/categorizing-tagging",
    icon: <Tag size={24} />,
    desc: "Hierarchical metadata structuring.",
  },
  {
    label: "Phonetic Transcription",
    path: "/services/phonetic-transcription",
    icon: <SearchCode size={24} />,
    desc: "Granular phonetic level mapping.",
  },
  {
    label: "Digital Marketing",
    path: "/services/digital",
    icon: <BarChart3 size={24} />,
    desc: "Strategic growth and data-driven SEO.",
  },
];

const productsMenu = [
  {
    label: "Enterprise ERP",
    path: "/Erp",
    icon: <Layers size={24} />,
    desc: "Unified resource planning for business orchestration.",
  },
  {
    label: "CRM & Billing",
    path: "/Crm",
    icon: <Users size={24} />,
    desc: "Advanced relationship management logic.",
  },
  {
    label: "Advanced HRM",
    path: "/Hrm",
    icon: <Zap size={24} />,
    desc: "Workforce management from recruitment to payroll.",
  },
  {
    label: "Billing Software",
    path: "/Billing",
    icon: <Receipt size={24} />,
    desc: "Automated invoicing and fiscal architectures.",
  },
];

export default function ServicesAndProducts() {
  return (
    <section className="font-inter overflow-hidden">
      {/* ========== SERVICES SECTION ========== */}
      <div className="bg-slate-50 py-20 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 mb-12">
          <span className="text-indigo-600 font-black tracking-[0.2em] uppercase text-[10px]">
            Engineering Capabilities
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 tracking-tight">
            High-Fidelity Services
          </h2>
        </div>

        {/* REMOVED 'group' from here, ADDED 'hover-pause' */}
        <div className="relative flex hover-pause">
          <div className="flex animate-marquee whitespace-nowrap gap-5 py-4">
            {[...servicesMenu, ...servicesMenu].map((item, index) => (
              <NavigationCard key={index} item={item} />
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-10">
          <Link
            to="/services"
            className="inline-flex items-center gap-3 bg-white border border-slate-200 px-6 py-2.5 rounded-full text-slate-900 font-bold text-sm uppercase tracking-widest hover:border-indigo-600 hover:shadow-lg transition-all group"
          >
            Explore All Services
            <span className="bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs group-hover:rotate-45 transition-transform duration-300">
              ↗
            </span>
          </Link>
        </div>
      </div>

      {/* ========== PRODUCTS SECTION ========== */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 mb-12 text-right">
          <span className="text-indigo-600 font-black tracking-[0.2em] uppercase text-[10px]">
            Technical Solutions
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 tracking-tight">
            Proprietary Software Suite
          </h2>
        </div>

        {/* REMOVED 'group' from here, ADDED 'hover-pause' */}
        <div className="relative flex hover-pause">
          <div className="flex animate-marquee-reverse whitespace-nowrap gap-5 py-4">
            {[...productsMenu, ...productsMenu, ...productsMenu].map(
              (item, index) => (
                <NavigationCard key={index} item={item} />
              ),
            )}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-10 flex justify-end">
          <Link
            to="/products"
            className="inline-flex items-center gap-3 bg-white border border-slate-200 px-6 py-2.5 rounded-full text-slate-900 font-bold text-sm uppercase tracking-widest hover:border-indigo-600 hover:shadow-lg transition-all group"
          >
            View Product Suite
            <span className="bg-[#4f46e5] text-white w-6 h-6 rounded-full flex items-center justify-center text-xs group-hover:rotate-45 transition-transform duration-300">
              ↗
            </span>
          </Link>
        </div>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0%); }
        }
        .animate-marquee { animation: marquee 50s linear infinite; }
        .animate-marquee-reverse { animation: marquee-reverse 30s linear infinite; }
        
        /* Updated to use .hover-pause instead of .group */
        .hover-pause:hover .animate-marquee,
        .hover-pause:hover .animate-marquee-reverse { animation-play-state: paused; }
      `,
        }}
      />
    </section>
  );
}

/* ------------------ REUSABLE NAVIGATION CARD ------------------ */

function NavigationCard({ item }) {
  return (
    <Link
      to={item.path}
      // 'group' here ensures hover styles only apply to this specific instance
      className="w-[320px] bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:border-indigo-500 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col items-start group"
    >
      <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600 mb-6 transition-colors duration-300 group-hover:bg-indigo-600 group-hover:text-white">
        {item.icon}
      </div>
      <h3 className="text-sm font-bold text-slate-900 mb-2 uppercase tracking-tight whitespace-normal">
        {item.label}
      </h3>
      <p className="text-slate-500 text-xs leading-relaxed whitespace-normal mb-4">
        {item.desc}
      </p>
      <p className="text-indigo-600 text-[9px] font-black uppercase tracking-[0.2em] opacity-70 group-hover:opacity-100 transition-opacity">
        Technical Specs ⟶
      </p>
    </Link>
  );
}